/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 12C6 15.3137 8.68629 18 12 18C15.3137 18 17.5 15 17.5 15M18 12C18 8.68629 15.3333 6 12 6C8 6 6.5 9 6.5 9M6.5 9V6.5M6.5 9H9M17.5 15H15M17.5 15V17.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6.5 15 6.5 15M6 12C6 8.68629 8.66667 6 12 6C16 6 17.5 9 17.5 9M17.5 9V6.5M17.5 9H15M6.5 15H9M6.5 15V17.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM12 5.25C9.79403 5.25 8.25089 6.08286 7.26191 6.93056L7.25 6.94079V6.5C7.25 6.08579 6.91421 5.75 6.5 5.75C6.08579 5.75 5.75 6.08579 5.75 6.5V9C5.75 9.41421 6.08579 9.75 6.5 9.75H9C9.41421 9.75 9.75 9.41421 9.75 9C9.75 8.58579 9.41421 8.25 9 8.25H8.03784C8.10091 8.19019 8.16764 8.12983 8.23809 8.06944C8.99911 7.41714 10.206 6.75 12 6.75C14.9175 6.75 17.25 9.0989 17.25 12C17.25 12.4142 17.5858 12.75 18 12.75C18.4142 12.75 18.75 12.4142 18.75 12C18.75 8.27368 15.7491 5.25 12 5.25ZM6.75 12C6.75 11.5858 6.41421 11.25 6 11.25C5.58579 11.25 5.25 11.5858 5.25 12C5.25 15.7279 8.27208 18.75 12 18.75C13.8867 18.75 15.4213 17.8974 16.4541 17.0912C16.5572 17.0107 16.6559 16.9303 16.75 16.8506V17.5C16.75 17.9142 17.0858 18.25 17.5 18.25C17.9142 18.25 18.25 17.9142 18.25 17.5V15C18.25 14.5858 17.9142 14.25 17.5 14.25H15C14.5858 14.25 14.25 14.5858 14.25 15C14.25 15.4142 14.5858 15.75 15 15.75H15.7281C15.6647 15.8027 15.5991 15.8558 15.5311 15.9088C14.6424 16.6026 13.427 17.25 12 17.25C9.1005 17.25 6.75 14.8995 6.75 12Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M6 12C6 15.3137 8.68629 18 12 18C15.3137 18 17.5 15 17.5 15M18 12C18 8.68629 15.3333 6 12 6C8 6 6.5 9 6.5 9M6.5 9V6.5M6.5 9H9M17.5 15H15M17.5 15V17.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 12C6 15.3137 8.68629 18 12 18C15.3137 18 17.5 15 17.5 15M18 12C18 8.68629 15.3333 6 12 6C8 6 6.5 9 6.5 9M6.5 9V6.5M6.5 9H9M17.5 15H15M17.5 15V17.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.26191 6.93056C8.25089 6.08286 9.79403 5.25 12 5.25C15.7491 5.25 18.75 8.27368 18.75 12C18.75 12.4142 18.4142 12.75 18 12.75C17.5858 12.75 17.25 12.4142 17.25 12C17.25 9.0989 14.9175 6.75 12 6.75C10.206 6.75 8.99911 7.41714 8.23809 8.06944C8.16764 8.12983 8.10091 8.19019 8.03784 8.25H9C9.41421 8.25 9.75 8.58579 9.75 9C9.75 9.41421 9.41421 9.75 9 9.75H6.5C6.08579 9.75 5.75 9.41421 5.75 9V6.5C5.75 6.08579 6.08579 5.75 6.5 5.75C6.91421 5.75 7.25 6.08579 7.25 6.5V6.94079C7.25396 6.93738 7.25793 6.93397 7.26191 6.93056ZM6 11.25C6.41421 11.25 6.75 11.5858 6.75 12C6.75 14.8995 9.1005 17.25 12 17.25C13.427 17.25 14.6424 16.6026 15.5311 15.9088C15.5991 15.8558 15.6647 15.8027 15.7281 15.75H15C14.5858 15.75 14.25 15.4142 14.25 15C14.25 14.5858 14.5858 14.25 15 14.25H17.5C17.9142 14.25 18.25 14.5858 18.25 15V17.5C18.25 17.9142 17.9142 18.25 17.5 18.25C17.0858 18.25 16.75 17.9142 16.75 17.5V16.8506C16.6559 16.9303 16.5572 17.0107 16.4541 17.0912C15.4213 17.8974 13.8867 18.75 12 18.75C8.27208 18.75 5.25 15.7279 5.25 12C5.25 11.5858 5.58579 11.25 6 11.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
